<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
    <div id="component-chat-log" class="m-8" >
        <div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">

            <!-- If previous msg is older than current time -->
            <template v-if="index == 0">
                <vs-divider class="msg-time">
                    <span>{{ toDate(msg.sentAtDtm) }}</span>
                </vs-divider>
                <div class="spacer mt-8" ></div>
            </template>
            <template v-if="chatData[index-1]">
                <vs-divider class="msg-time" v-if="!isSameDay(toDate(chatData[index].sentAtDtm),toDate(chatData[index-1].sentAtDtm))">
                    <span>{{ toDate(msg.sentAtDtm) }}</span>
                </vs-divider>
                <div class="spacer mt-8" ></div>
            </template>

            <div class="flex items-start" :class="getReverseClass(index)">
                <template v-if="index > 0">
                    <template >
                        <div class="avatar-option">
                          <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" :src="msg.senderPhotoUrl"></vs-avatar>
                         <div class="delete-attendee" @click="deleteUserFromRoom(msg.senderId)"><vx-tooltip color="danger" :text="`Remove ${msg.senderName} from this Group`"><span>X</span></vx-tooltip></div>
                        </div>
                        
                    </template>
                </template>

                <template v-if="index == 0">
                  <div class="avatar-option">
                    <vs-avatar size="40px" class="border-2 shadow border-solid border-white m-0 flex-shrink-0" :class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" :src="msg.senderPhotoUrl"></vs-avatar>
                    <div class="delete-attendee" @click="deleteUserFromRoom(msg.senderId)"><vx-tooltip color="danger" :text="`Remove ${msg.senderName} from this Group`"><span>X</span></vx-tooltip></div>
                  </div>
                </template>

                <div class="msg attendees-chat-data break-words relative shadow-md rounded py-3 px-4 mb-2 mr-3 rounded-lg max-w-sm" :class="{'bg-primary text-white': msg.isSent, 'border border-solid border-transparent bg-white': !msg.isSent}">
                    
                    <div class="message-box">
                      <span v-if="['TEXT', 'EVENT-NOTIFICATION'].includes(msg.msgType)">{{ msg.msgText }}</span>
                      <span v-else-if="msg.fileUrl"><a href="javascript:void(0)" @click="downloadFile(msg.fileUrl)">Download File</a></span>
                      <div class="emoji-capture">
                        <ul>
                          <li v-for="react in reacts" v-if="msg.reactionCounts && msg.reactionCounts[react.id]"> {{react.icon}} <span>{{msg.reactionCounts[react.id]}}<sup v-if="msg.reactionCounts[react.id]>99">+</sup></span></li>
                        </ul>
                      </div>
                    </div>



                    <div class="chat-option-dropdown">
                      <vs-dropdown vs-custom-content vs-trigger-click>
                        <a class="flex items-center" href.prevent>
                          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1" />
                        </a>

                        <vs-dropdown-menu class="dropdown-login">
                          <div class="option-list">
                            <ul>
                              <li><a href="javascript:void(0)" @click="unpublishMessage(msg.id)">Delete message</a></li>
                            </ul>
                          </div>
                        </vs-dropdown-menu>

                      </vs-dropdown>
                    </div>
                </div>
            </div>




            
        </div>
        
    </div>
</template>

<script>
import moment from "moment-timezone";
import ls from "@/common/localStorage";
export default{
  props: {
    roomId: {
      type: String,
      required: true
    }
  },
  data(){
    return{
      reacts: [
        {
          id: 1,
          icon: '👍'
        },
        {
          id: 2,
          icon: '❤'
        },
        {
          id: 3,
          icon: '😃'
        },
        {
          id: 4,
          icon: '😎'
        },
        {
          id: 5,
          icon: '😢'
        },
        {
          id: 6,
          icon: '😡'
        },
        {
          id: 7,
          icon: '👎'
        }
      ]
    }
  },
  computed: {
    chatData () {
      return this.$store.state.chatgroupManagement.chatgroupmessages;
    },
    activeUserImg () {
      return this.$store.state.AppActiveUser.photoURL
    },
    senderImg () {
      return (isSentByActiveUser) => {
        if (isSentByActiveUser) return this.$store.state.AppActiveUser.photoURL
        else return this.$store.getters['chat/contact'](this.roomId).iconUrl
      }
    },
    hasSentPreviousMsg () {
      return (last_sender, current_sender) => last_sender === current_sender
    }
  },
  methods: {
    downloadFile(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      var a = document.createElement('a');
      a.href = downloadUrl;
      a.download = name;
      a.target = "_blank"
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    getReverseClass(index){
      let rowClass = ''
      this.$store.state.chatgroupManagement.chatgroupmessages[index].rowClass = ''
      if(index > 0){
        let prev = this.$store.state.chatgroupManagement.chatgroupmessages[index-1]
        let current = this.$store.state.chatgroupManagement.chatgroupmessages[index]        
        if(prev.senderId == current.senderId)
          current.rowClass = prev.rowClass;
        else
          current.rowClass = prev.rowClass == 'flex-row-reverse' ? '' : 'flex-row-reverse';
        rowClass = current.rowClass;        
        this.$store.state.chatgroupManagement.chatgroupmessages[index-1] = prev
        this.$store.state.chatgroupManagement.chatgroupmessages[index] = current
      }
      return rowClass
    },
    isSameDay (time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to))
      const date_time_from = new Date(Date.parse(time_from))
      return date_time_to.getFullYear() === date_time_from.getFullYear() &&
                date_time_to.getMonth() === date_time_from.getMonth() &&
                date_time_to.getDate() === date_time_from.getDate()
    },
    toDate (val) {
      let strDateTime = new Date(val.seconds*1000).toUTCString();
      let timeZone = ls.getSessionValueByKey('Session_Event_TZ');
      return moment(strDateTime).utc().format('MMMM DD, YYYY');
    },
    parseDate(val){
      return new Date(val.seconds*1000)
    },
    scrollToBottom () {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
      })
    },
    unpublishMessage(msgId){
      this.$vs.loading();
      this.$store.dispatch("chatgroupManagement/unpublishMessage", {
        roomId: this.roomId,
        msgId: msgId
      }).then((res) => {
        this.$vs.loading.close();
      }).catch(err=>{ this.$vs.loading.close(); })
    },
    deleteUserFromRoom(userId){
      this.$vs.loading();
      this.$store.dispatch("chatgroupManagement/deleteUserFromRoom", {
        roomId: this.roomId,
        userIdList: [userId]
      }).then((res) => {
        this.$vs.loading.close();
        if(res.status == 200){
          this.$vs.notify({
              color: "success",
              position: "top-center",
              text: "User Removed Successfully.",
            });
        }
      }).catch(err=>{ this.$vs.loading.close(); })
    }
  },
  updated () {
    this.scrollToBottom()
  },
  mounted () {
    this.scrollToBottom();    
    //this.$store.dispatch('chatgroupManagement/listenChatGroupMessages', this.roomId);
  },
}
</script>
